import React, { useEffect, useState } from "react";
import { Loader2, Monitor, Smartphone, ArrowLeft, Eye } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";

export const PREVIEW_KEY = "qf_preview_payload";

export default function PreviewModal({ open, onOpenChange, buildPayload, quoteId }) {
  const [device, setDevice] = useState("desktop");
  const [stamp, setStamp] = useState(null);

  useEffect(() => {
    if (!open) { setStamp(null); return; }
    (async () => {
      try {
        const { data } = await api.post(`/quotes/preview${quoteId ? `?quote_id=${quoteId}` : ""}`, buildPayload(false));
        localStorage.setItem(PREVIEW_KEY, JSON.stringify(data));
        setStamp(Date.now());
      } catch (e) {
        toast.error(e?.response?.data?.detail?.[0]?.msg || e?.response?.data?.detail || "Impossibile generare l'anteprima");
        onOpenChange(false);
      }
    })();
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="preview-modal" className="max-w-none w-screen h-[100dvh] p-0 gap-0 rounded-none sm:rounded-none flex flex-col bg-slate-100 [&>button]:hidden">
        <div className="flex items-center justify-between gap-3 px-4 py-3 bg-card border-b border-slate-200">
          <div className="min-w-0">
            <DialogTitle className="text-sm font-bold flex items-center gap-2"><Eye style={{ width: 16, height: 16 }} className="text-primary" /> Anteprima Vista Cliente</DialogTitle>
            <DialogDescription className="text-xs hidden sm:block">Sola lettura · include le modifiche non ancora salvate</DialogDescription>
          </div>
          <div className="flex items-center gap-1 rounded-lg bg-slate-100 p-1">
            {[["desktop", Monitor, "Desktop"], ["mobile", Smartphone, "Mobile"]].map(([v, Icon, l]) => (
              <button key={v} type="button" data-testid={`preview-device-${v}`} onClick={() => setDevice(v)}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-semibold transition-colors ${device === v ? "bg-card shadow-sm text-slate-900" : "text-slate-500"}`}>
                <Icon style={{ width: 14, height: 14 }} /> <span className="hidden sm:inline">{l}</span>
              </button>
            ))}
          </div>
          <button type="button" data-testid="preview-back-button" onClick={() => onOpenChange(false)}
            className="h-9 px-3 sm:px-4 rounded-lg bg-primary text-primary-foreground text-sm font-semibold flex items-center gap-1.5 shadow-sm hover:bg-primary/90 transition-colors shrink-0">
            <ArrowLeft style={{ width: 16, height: 16 }} /> <span className="hidden sm:inline">Torna al preventivo</span><span className="sm:hidden">Indietro</span>
          </button>
        </div>
        <div className="flex-1 overflow-hidden flex items-start justify-center p-0 sm:p-4">
          {!stamp ? (
            <div className="py-24"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>
          ) : (
            <iframe key={stamp} title="Anteprima preventivo" data-testid="preview-iframe" src={`/preview-frame?t=${stamp}`}
              className={`bg-card border-0 transition-[width] duration-300 ${device === "mobile" ? "w-[390px] max-w-full h-full sm:h-[780px] sm:rounded-[28px] sm:border-[10px] sm:border-slate-900 shadow-2xl" : "w-full h-full sm:rounded-xl shadow"}`} />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
